import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationFundsPage} from 'features/deposit/onboarding/pages/DepositApplicationFundsPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/$productCode/$accountId',
)({
  component: DepositApplicationFundsPage,
});
